import React from 'react';
import { Check, Trophy } from 'lucide-react';
import Button from '../../components/Button/Button';
import './BLXMCourse.css';

const BLXMCourse: React.FC = () => {
  return (
    <div className="blxm-course">
      {/* Hero Section */}
      <section className="blxm-hero">
        <div className="container">
          <div className="blxm-hero-content">
            <h1 className="blxm-hero-title">BLXM Course</h1>
            <p className="blxm-hero-subtitle">
              Our flagship 12-week executive development program for professionals of all levels
            </p>
          </div>
        </div>
      </section>

      {/* Course Details Section */}
      <section className="section blxm-details">
        <div className="container">
          <div className="blxm-card">
            <div className="blxm-card-header">
              <div className="blxm-icon">
                <Trophy size={40} />
              </div>
              <h2 className="blxm-course-name">Baseline Executive Mastermind Course</h2>
              <p className="blxm-course-description">
                Our flagship 12-week executive development program for professionals of all levels
              </p>
            </div>

            <div className="blxm-card-body">
              <ul className="blxm-features">
                <li className="blxm-feature">
                  <Check size={20} className="feature-check" />
                  <span>10-module comprehensive curriculum</span>
                </li>
                <li className="blxm-feature">
                  <Check size={20} className="feature-check" />
                  <span>Industry-expert recorded modules</span>
                </li>
                <li className="blxm-feature">
                  <Check size={20} className="feature-check" />
                  <span>Personalized coaching and mentorship</span>
                </li>
                <li className="blxm-feature">
                  <Check size={20} className="feature-check" />
                  <span>Real-world case studies</span>
                </li>
                <li className="blxm-feature">
                  <Check size={20} className="feature-check" />
                  <span>Collaborative peer network</span>
                </li>
                <li className="blxm-feature">
                  <Check size={20} className="feature-check" />
                  <span>Professional certification upon completion</span>
                </li>
                <li className="blxm-feature">
                  <Check size={20} className="feature-check" />
                  <span>Lifetime access to course materials</span>
                </li>
                <li className="blxm-feature">
                  <Check size={20} className="feature-check" />
                  <span>Alumni network access</span>
                </li>
              </ul>
            </div>

            <div className="blxm-card-footer">
              <Button
                variant="primary"
                size="large"
                href="/contact"
                fullWidth
              >
                Enroll Now
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section blxm-cta-section">
        <div className="container">
          <div className="blxm-cta-content">
            <h2 className="cta-title">Ready to Transform Your Career?</h2>
            <p className="cta-subtitle">
              Schedule a free consultation with our team to learn more about the BLXM Course
            </p>
            <Button variant="primary" size="large" href="https://calendar.app.google/zeaz1ocNpttMocbv7">
              Schedule Your Free Consultation
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BLXMCourse;

